export const config = {
  chatPaywallEnabled: false,
  chatPaywallLimit: 3,
  formalNoticePaywallEnabled: true,
};
